import configUrl from '../config/configUrl';
class Config{


    url = configUrl.ordinaryUrl;
    getRequest = "/analysisReport/getCrossQuestion";//获取问题列表
    getCrossList="/analysisReport/crossList";//获取交叉分析表格
    pieChart="/analysisReport/crossTotalCharts";//饼状图接口
    histogram="/analysisReport/crossColCharts";//柱状图接口
    saveQuestion = "/testPager/create"; //保存新建问卷
    updateQuestion = "/testPager/paperSetting"; //更新正在操作的问卷
    // loadQuestionData = "/testPager/list"; //获取问卷列表
    loadQuestionData = "/questionnair/wx_MyQuestionList";
    deleteFromQuestionData = "/testPager/updateTestPaper"; //从问卷列表删除问卷

    saveQuestionSubject = "/testPager/insertQuestion"; //保存新建题目
    // getCurrentQuestionAllSubject = "/testPager/getPaperQuestions"; //获取当前问卷所有的题目
    deleteQuestionSubject= '/testPager/deleteQuestion';//删除题目
    moveQuestionSubjectUp = "/testPager/moveUp";//上移题目
    moveQuestionSubjectDown = "/testPager/moveDown";//下移题目
    updateQuestionSubject = "/testPager/updateQuestion"; //更新题目内容
    singleQuestionAnalysis="analysisReport/single";//单题分析接口
    getFieldValue="dictValueController/getFieldValue";//获取人员属性动态值

    getRecoveryCharts = "/recovery/processing";//获取回收页条形图数据
    getRecoveryTable = "/recovery/search";//获取回收页表格数据(含搜索)
    getRecoveryDownload = "/recovery/download";//获取回收页导出数据(含搜索)
    getRecoveryDel = "/recovery/delAnswer";//获取回收页删除
    propagationQR = "/spread/code";//获取传播二维码

    // saveQuestionAnswer = "/answer/save";//答卷提交

    getStr(str){
        return config[str];
    }
}
let config = new Config();
export default config;